import React from 'react';
import { Icon, TooltipHost } from '@fluentui/react';
import EditModal from '../../EditSite/EditModal';
import SiteHistoryModal from '../SiteDetails/SiteHistoryModal';
import PowerAppSolutionEditModal from '../../EditSite/PowerAppSolutionEditModal';
import { PowerAppProvisioningStatus } from '../../../GlobalConst/globalEnums';

class ActionButtonsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showEditModal: false,
            showHistoryModal: false,
        }
    }

    showEditModal = () => {
        this.setState({showEditModal: true})
    }

    onCloseEditModal = () => {
        this.setState({showEditModal: false})
    }
    showHistoryModal = () => {
        this.setState({showHistoryModal: true})
    }

    onCloseHistoryModal = () => {
        this.setState({showHistoryModal: false})
    }

    onShowSolutionModal = (solutionId) => {
        this.setState({showEditModal: false, solutionId, showSolutionModal: true})
    }

    onCloseSolutionModal = () => {
        this.setState({showSolutionModal: false })
    }

    render() {
        let taskIcon = null;
        let licenseTasks = this.props.editedItem.requestLicenseTasks.filter(a => a.status === 1);
        if(licenseTasks.length > 0 ) {
            taskIcon = <TooltipHost content={'This app has pending license requests'}>
                                <Icon iconName='important' style={iconStyles} />
                       </TooltipHost>
        }

        const updatesIcon = this.props.filterBy === 'owner' && [PowerAppProvisioningStatus.updating, PowerAppProvisioningStatus.pendingApproval, PowerAppProvisioningStatus.failed, PowerAppProvisioningStatus.permanentFailed].includes(this.props.editedItem.provisioningStatus) &&
            <TooltipHost content='Updates are in progress' styles={iconStyles}>
                <Icon iconName='workflow' style={updatesIconStyles} />
            </TooltipHost>

        return(
            <div style={iconContainerStyles}>
                {
                    updatesIcon
                    ? updatesIcon
                    : <div>
                        <Icon style={editIconStyles} onClick={this.showEditModal} iconName="edit" />
                        <EditModal
                            itemId={this.props.editedItem.id}
                            isModalOpened={this.state.showEditModal} 
                            onCloseModal={this.onCloseEditModal} 
                            callBack={this.props.callBack}
                            isPowerApp={true}
                            showSolutionModal={this.onShowSolutionModal}
                        />
                    </div>
                }
                {
                    this.props.filterBy !== 'owner' &&
                    <div>
                        <Icon style={iconStyles} onClick={this.showHistoryModal} iconName="diagnostic" />   
                        <SiteHistoryModal 
                            powerAppId={this.props.editedItem.id}
                            title={this.props.editedItem.name}
                            isModalOpened={this.state.showHistoryModal} 
                            onCloseModal={this.onCloseHistoryModal} 
                        />
                    </div>
                }
                <div>
                    {taskIcon}
                </div>
                <PowerAppSolutionEditModal
                    solutionId={this.state.solutionId}
                    showModal={this.state.showSolutionModal}
                    onCloseModal={this.onCloseSolutionModal}
                    callback={this.props.callBack}
                />
            </div>
        )
    }
    
}

const iconContainerStyles = {
    display: 'flex'
}

const editIconStyles = {
    cursor: 'pointer',
    margin: '1px 5px',
    fontSize: '14px',
    fontWeight: '600'
}

const iconStyles = {
    cursor: 'pointer',
    margin: '0 5px',
    fontSize: '16px',
    fontWeight: '600'
}

const updatesIconStyles = {
    fontSize: '16px',
    color: 'orange',
    margin: '0 5px',
    cursor: 'default'
}

export default ActionButtonsView;


// WEBPACK FOOTER //
// ./src/components/Administration/PowerPlatform/ActionButtonsView.js